/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useState, useRef } from 'react';
import { MyContext } from '../../Context/MyProvider';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { MdContentCopy } from 'react-icons/md';
import { showTost } from '../../showTost';
import html2canvas from "html2canvas";
import Loading from '../../Loading';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';
import { formatMoney, getSiteCurrency } from '../../utils/money';
const Ticket = () => {

    const { t } = useTranslation();
    const { BaseUrl } = useContext(MyContext);

    const [ticketDetails, setTicketDetails] = useState();
    const [loading, setLoading] = useState(true);
    const [rating, setRating] = useState(1);
    const [reviewText, setReviewText] = useState();
    const [showreviewbox, setShowReviewBox] = useState(false);

    const currency = getSiteCurrency();

    const receiptRef = useRef();
    const hidden = useRef();

    const Location = useLocation();
    const Data = Location.state;

    useEffect(() => {
        window.scrollTo(0, 0);
        HandleFetchData();
    }, [Data]);

    const HandleFetchData = () => {
        const Userid = localStorage.getItem("Userid");
        if (Userid) {
            axios.post(`${BaseUrl}user_api/ticket_information.php`, { uid: Userid, ticket_id: Data.Ticketdata.ticket_id })
                .then((res) => {
                    console.log("ticket_information", res);
                    setTicketDetails(res.data.TicketData);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("ticket_information", error);
                });
        }
    }

    const handleCopyClick = (textToCopy) => {
        navigator.clipboard.writeText(textToCopy).then(() => {
            showTost(t("Text copied to clipboard !!"), "success");
        }).catch((err) => {
            console.error('Failed to copy text: ', err);
        });
    };

    const handleDownload = () => {
        hidden.current.style.display = "none";
        html2canvas(receiptRef.current, {
            allowTaint: true,
            useCORS: true,
        }).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const link = document.createElement('a');
            link.href = imgData;
            link.download = 'receipt.png';
            link.click();
            hidden.current.style.display = "block";
        }).catch((error) => {
            console.error("Error generating the image:", error);
        });
    };

    const HandleGiveReview = () => {
        const Userid = localStorage.getItem("Userid");
        if (Userid) {
            axios.post(`${BaseUrl}/user_api/rate_update.php`, { uid: Userid, ticket_id: Data.Ticketdata.ticket_id, total_star: rating, review_comment: reviewText || "" })
                .then((res) => {
                    // console.log("rate_update", res);
                    showTost(res.data.ResponseMsg, "success");
                    setShowReviewBox(false);
                    setRating(1);
                    HandleFetchData();
                })
                .catch((error) => {
                    console.error("rate_update", error);
                })
        }
    }

    return (
        <div className="width_container">

            <div className="flex items-center gap-[10px] justify-between mt-[10px] max-_430_:hidden">
                <div className="flex items-center gap-[10px] border-[2px] rounded-[50px] px-[10px] py-[5px] cursor-pointer hover:bg-[#23262F] group">
                    <HiChevronLeft className="group-hover:text-white" />
                    <Link to="/" className="font-bold text-[14px] group-hover:text-white">{t("Go home")}</Link>
                </div>
                <div className="flex items-center gap-[15px]">
                    <Link to="/booking" className="font-bold text-[14px] text-gray-600">{t("Bookings")}</Link>
                    <HiChevronRight />
                    <h1 className="font-bold text-[14px] text-gray-400">{t("E - Ticket")}</h1>
                </div>
            </div>

            <div className="my-[20px]">
                <div className="ticket_box2">
                    <div ref={receiptRef} className="">
                        <div className="mb-[20px]">
                            <img src={ticketDetails?.qrcode} className="mx-auto w-[150px]" alt="QR Code" />
                            <div className="flex items-center gap-[10px] justify-center">
                                <h1 onClick={() => handleCopyClick(ticketDetails?.unique_code)} className="cursor-pointer" >{ticketDetails?.unique_code}</h1>
                                <span onClick={() => handleCopyClick(ticketDetails?.unique_code)} ref={hidden} className="cursor-pointer" >< MdContentCopy /></span>
                            </div>
                        </div>

                        <div className="max-w-2xl mx-auto p-6 bg-white">

                            <h2 className="text-xl font-bold">{ticketDetails?.ticket_title}</h2>
                            <p className="text-sm text-gray-600">{ticketDetails?.sponsore_title}</p>

                            <div className="mt-4">
                                <p className="text-sm text-gray-600">{t("Dates")}</p>
                                <p className="text-sm font-semibold">{ticketDetails?.start_time}</p>
                            </div>

                            <div className="mt-4">
                                <p className="text-sm text-gray-600">{t("Location")}</p>
                                <p className="text-sm font-semibold">
                                    {ticketDetails?.event_address_title}
                                </p>
                            </div>

                            <div className="mt-6">
                                <h3 className="text-[20px] font-bold">{t("Booking details")}</h3>
                                <div className="grid grid-cols-2 gap-y-2 mt-3 text-sm">

                                    <span className="text-gray-600">{t("Full Name")}</span>
                                    <span>{ticketDetails?.ticket_username}</span>

                                    <span className="text-gray-600">{t("Phone")}</span>
                                    <span>{ticketDetails?.ticket_mobile}</span>

                                    <span className="text-gray-600">{t("Email")}</span>
                                    <span>{ticketDetails?.ticket_email}</span>

                                    <span className="text-gray-600">{t("Seats")}</span>
                                    <span>{ticketDetails?.total_ticket}</span>

                                    <span className="text-gray-600">{t("Tax")}</span>
                                    <span>{formatMoney(ticketDetails?.ticket_tax, currency)}</span>

                                    <span className="text-gray-600">{t("Wallet")}</span>
                                    <span>{formatMoney(ticketDetails?.ticket_wall_amt, currency)}</span>

                                    <span className="text-gray-600">{t("Coupon")}</span>
                                    <span>{formatMoney(ticketDetails?.ticket_cou_amt, currency)}</span>

                                    <span className="text-gray-600">{t("Total")}</span>
                                    <span>{formatMoney(ticketDetails?.ticket_total_amt, currency)}</span>

                                    <span className="text-gray-600">{t("Payment Method")}</span>
                                    <span>{ticketDetails?.ticket_p_method}</span>


                                    {ticketDetails?.ticket_transaction_id !== '0' && <>
                                        <span className="text-gray-600">{t("Transaction ID")}</span>
                                        <span>{ticketDetails?.ticket_transaction_id}</span>
                                    </>}

                                    {ticketDetails?.ticket_status === "Cancelled" && <>
                                        <span className="text-gray-600">{t("Ticket Status")}</span>
                                        <span>{ticketDetails?.ticket_status}</span>
                                    </>}

                                </div>
                            </div>
                        </div>
                    </div>

                    {ticketDetails?.ticket_status !== "Cancelled" && <button onClick={handleDownload} className="button">{t("Download Ticket")}</button>}
                    {(Data.type === "Completed" && ticketDetails?.ticket_status !== "Cancelled" && ticketDetails?.ticket_rate === "0") && <button className='review_button' onClick={() => setShowReviewBox(true)}>{t("Review")}</button>}

                </div>
            </div>

            {loading && <Loading />}

            {showreviewbox && <div onClick={() => setShowReviewBox(false)} style={{ alignItems: "end" }} className="bottom_model">
                <div onClick={(e) => e.stopPropagation()} className="bottom_box">
                    <h1 className='font-bold text-[20px] text-center pb-[5px]'>{t("Leave a Review")}</h1>
                    <div className="border-t-[1px] pb-[10px]"></div>
                    <div className="pb-[10px]">
                        <h1 className='text-[15px] text-center'>{t("How was your experience")}</h1>
                        <div className="flex items-center justify-center gap-[5px] mt-[10px]">
                            {[1, 2, 3, 4, 5].map((index) => {
                                return <div key={index} onClick={() => setRating(index)} className="cursor-pointer">
                                    <svg width="28" height="28" viewBox="0 0 24 24" fill={rating >= index ? "blue" : "none"} xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.0328 3.27141C10.8375 1.5762 13.1625 1.57619 13.9672 3.27141L15.3579 6.20118C15.6774 6.87435 16.2951 7.34094 17.0096 7.44888L20.1193 7.91869C21.9187 8.19053 22.6371 10.4895 21.3351 11.8091L19.0849 14.0896C18.5679 14.6136 18.332 15.3685 18.454 16.1084L18.9852 19.3285C19.2926 21.1918 17.4116 22.6126 15.8022 21.7329L13.0208 20.2126C12.3817 19.8633 11.6183 19.8633 10.9792 20.2126L8.19776 21.7329C6.58839 22.6126 4.70742 21.1918 5.01479 19.3286L5.54599 16.1084C5.66804 15.3685 5.43211 14.6136 4.91508 14.0896L2.66488 11.8091C1.36287 10.4895 2.08133 8.19053 3.88066 7.91869L6.99037 7.44888C7.70489 7.34094 8.32257 6.87435 8.64211 6.20118L10.0328 3.27141Z" stroke="#0000ffb7" stroke-width="1.5" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            })}
                        </div>
                    </div>
                    <div className="border-t-[1px] pb-[10px]"></div>
                    <div className="pb-[10px]">
                        <h1 className='text-[15px] text-center mb-[10px]'>{t("Write Your Review")}</h1>
                        <textarea onChange={(e) => setReviewText(e.target.value)} className='w-[100%] min-h-[100px] max-h-[100px] px-[10px] py-[5px] focus-within:outline-[#0000ffb7] border-[2px] bprder-[#8080803b] rounded-[10px]' placeholder={t('Your reviewe here..')} />
                    </div>
                    <div className="border-t-[1px] pb-[10px]"></div>
                    <div className="pb-[10px] flex items-center gap-[10px]">
                        <button onClick={() => setShowReviewBox(false)} className='w-[100%] text-[#0000ffb7] border-[2px] border-[#0000ffb7] py-[8px] rounded-[10px] font-bold'>{t("Maybe Later")}</button>
                        <button onClick={HandleGiveReview} style={{ marginTop: "0" }} className='button'>{t("Submit")}</button>
                    </div>
                </div>
            </div>}

        </div>
    )
}

export default Ticket
/* jshint ignore:end */
